module.exports = __webpack_public_path__ + "static/sungevity-logo-9146a9f65b9530d3250b020a9bfa322c.png";